import { useEffect, useState } from 'react';
import { api } from '../services/api.js';

export default function LinksList({ recarregarRef }) {
  const [items, setItems] = useState([]);
  const [cursor, setCursor] = useState(null);
  const [carregando, setCarregando] = useState(true);
  const [erro, setErro] = useState(null);

  async function carregar(novoCursor = null) {
    setCarregando(true);
    setErro(null);
    try {
      const data = await api.linksListar(novoCursor || undefined);
      setItems((prev) => (novoCursor ? [...prev, ...data.links] : data.links));
      setCursor(data.cursor);
    } catch (err) {
      setErro(err.message || 'Falha ao listar.');
    } finally {
      setCarregando(false);
    }
  }

  useEffect(() => {
    carregar();
    if (recarregarRef) {
      recarregarRef.current = () => carregar();
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <section aria-labelledby="titulo-meus-links">
      <h2 id="titulo-meus-links" className="h4 mb-3">Meus links</h2>
      {erro && <div className="alert alert-danger">{erro}</div>}
      {items.length === 0 && !carregando ? (
        <p className="text-secondary">Você ainda não tem links cadastrados.</p>
      ) : (
        <ul className="list-group" aria-busy={carregando}>
          {items.map((it) => (
            <li key={it.short_link} className="list-group-item bg-transparent text-light border-secondary">
              <div className="d-flex justify-content-between align-items-start gap-3 flex-wrap">
                <div>
                  <div><strong>{it.nome}</strong></div>
                  <a href={it.short_link} target="_blank" rel="noreferrer">{it.short_link}</a>
                  <div className="text-secondary small text-truncate" style={{ maxWidth: '420px' }}>{it.link}</div>
                </div>
                <div aria-label={`${it.cliques} cliques`} className="badge bg-secondary align-self-center">
                  {it.cliques} cliques
                </div>
              </div>
            </li>
          ))}
        </ul>
      )}
      {cursor && (
        <button type="button" className="btn btn-outline-light mt-3" onClick={() => carregar(cursor)} disabled={carregando}>
          Carregar mais
        </button>
      )}
    </section>
  );
}
